module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Bold.dc90e389c8038f67dda0844915cce632.eot";